import { Controller } from "@hotwired/stimulus"
import { useIntersection } from 'stimulus-use'

// Connects to data-controller="autoclick"
export default class Autoclick extends Controller {
  connect() {
    this.clicked = false;
    useIntersection(this, {
      rootMargin: "10px"
    });
  }

  appear(entry, observer) {
    // callback automatically triggered when the element
    // intersects with the viewport (or root Element specified in the options)
    if (this.clicked) return

    this.clicked = true;
    const messagesContainer = document.getElementById("messages");
    const topMessage = messagesContainer?.children?.[0];
    this.element.click();

    setTimeout(() => {
      topMessage?.scrollIntoView({
        behavior: "auto",
        block: "end"
      });
    }, 250);
  }

  disappear(entry, observer) {
    // callback automatically triggered when the element
    // leaves the viewport (or root Element specified in the options)
  }

}
